export const engagementCanvasSendToDestinationRelatedCanvases =
  "/engagement/canvas/send_to_destination_related_canvases(/:canvas_id)";
